export default __webpack_public_path__ + "static/media/default-image-upload.d150577c.svg";